// extracted by mini-css-extract-plugin
export default {"title":"D--z","warning":"E--z","sizeOptionsLegendText":"F--z"};